import { Routes } from "@angular/router";

export const content: Routes = [
    {
        path: "dashboard",
        loadChildren: () => import('src/app/modules/dashboard/dashboard.module').then((m) => m.DashboardModule),
    },
    {
        path: "product",
        loadChildren: () => import('src/app/modules/catalog/product/product-routing.module').then(m => m.ProductRoutingModule)
    },
    {
        path: "order",
        loadChildren: () => import('src/app/modules/order/order.module').then(m => m.OrderModule)
    },
    {
        path: "catalog",
        loadChildren: () => import('src/app/modules/catalog/catalog.module').then(m => m.CatalogModule),
    },
    {
        path: "quality-control",
        loadChildren: () => import('src/app/modules/qc/qc-routing.module').then(m => m.QCRoutingModule),
    },
     {
        path: "shipping",
        loadChildren: () => import('src/app/modules/shipping/shipping.module').then((m) => m.ShippingModule)
    },
    {
        path: "payment",
        loadChildren: () => import('src/app/modules/order/order-list/payments/payments.module').then((m) => m.PaymentsModule)
    },
    {
        path: "user-management",
        loadChildren: () => import('src/app/modules/users/users.module').then((m) => m.UsersModule)
    },
    {
        path: "user-management",
        loadChildren: () => import('src/app/modules/user-management/employee/employee.module').then((m) => m.EmployeeModule)
    },
    {
        path:"masters",
        loadChildren: () =>import ('src/app/modules/masters/masters.module').then((m) =>m.MastersModule)
    },

    {
        path: "settings",
        loadChildren: () => import('src/app/modules/settings/settings.module').then((m) => m.SettingsModule)
    },
    {
        path: "menu-master",
        loadChildren: () => import('src/app/modules/menu-master/menu-master.module').then((m) => m.MenuMasterModule)
    },
   
    {
        path: "marketing",
        loadChildren: () => import('src/app/modules/marketplace-marketing/marketplace-marketing.module').then((m) => m.MarketplaceMarketingModule)
    },

    {
        path: "attribute",
        loadChildren: () => import('src/app/modules/catalog/attribute/attribute.module').then(m => m.AttributeModule),
    },
    {
        path: "cms",
        loadChildren: () => import('src/app/modules/cms/cms-routing.module').then(m => m.CmsRoutingModule),
    },
    {
        path: "marketplace-marketing",
        loadChildren: () => import('src/app/modules/marketplace-marketing/marketplace-marketing.module').then(m => m.MarketplaceMarketingModule),
    },
    {
        path: "help-desk",
        loadChildren: () => import('src/app/modules/help-desk/help-desk.module').then(m => m.HelpDeskModule),
    },
    // {
    //     path: "ticket",
    //     loadChildren: () => import('src/app/modules/ticket/ticket.module').then(m => m.TicketModule),
    // }, 
    {
        path: "ticket",
        loadChildren: () => import('src/app/modules/tickets/tickets.module').then(m => m.TicketsModule),
    },
];
